import React from "react";
import {FormattedMessage} from "react-intl";
import classNames from "classnames";
import closeIcon from "images/chat/ic_close.svg";
import headsetIcon from "images/voiceChat/ic_headset.svg";
import micIcon from "images/voiceChat/ic_microphone.svg";
import dropdownIcon from "assets/image/Layout/PropertyPanel/ic_dropdown_fold.svg";
import styles from "./index.module.scss";

function View({
  dismiss,
  onClickClose,
  speakerVolume,
  speakerList,
  isSpeakerListOpen,
  currentSpeaker,
  isTestMode,
  micVolume,
  micList,
  currentMic,
  isMicListOpen,
  micTestLevel,
  onClickList,
  onChangeRange,
  onClickTest,
  onClickDevice,
}) {
  return (
    <div className={styles.voice_chat_setting_popup}>
      <img className={styles.close_btn} onClick={onClickClose} src={closeIcon} alt="close" />
      <div className={styles.title}>
        <FormattedMessage id="ID_VOICE_CHAT_SETTING_TITLE" />
      </div>
      <div className={styles.scroll_wrap}>
        <Content
          type="speaker"
          titleId="ID_VOICE_CHAT_SETTING_SPEAKER"
          value={speakerVolume}
          imgSrc={headsetIcon}
          list={speakerList || []}
          listOpen={isSpeakerListOpen}
          currentDevice={currentSpeaker}
          isTestMode={isTestMode && "speaker" === isTestMode}
          onClickList={onClickList}
          onChange={onChangeRange}
          onClickTest={onClickTest}
          onClickDevice={onClickDevice}
        />
        <Content
          type="mic"
          titleId="ID_VOICE_CHAT_SETTING_MIC"
          value={micVolume}
          imgSrc={micIcon}
          list={micList || []}
          currentDevice={currentMic}
          listOpen={isMicListOpen}
          isTestMode={isTestMode && "mic" === isTestMode}
          micTestLevel={micTestLevel}
          onClickList={onClickList}
          onChange={onChangeRange}
          onClickTest={onClickTest}
          onClickDevice={onClickDevice}
        />
      </div>
      <div className={styles.button_wrap}>
        <button type="button" onClick={onClickClose} className={classNames(styles.cancel_btn)}>
          <FormattedMessage id="ID_POPUP_BTN_CANCEL" />
        </button>
        <button type="button" onClick={dismiss} className={classNames(styles.confirm_btn)}>
          <FormattedMessage id="ID_POPUP_BTN_SAVE" />
        </button>
      </div>
    </div>
  );
}

const Content = ({
  type,
  titleId,
  imgSrc,
  value,
  list,
  listOpen,
  isTestMode,
  micTestLevel,
  currentDevice,
  onClickList,
  onChange,
  onClickTest,
  onClickDevice,
}) => {
  return (
    <div className={styles.content}>
      <div className={styles.content_header}>
        <p className={styles.content_title}>
          <FormattedMessage id={titleId} />
        </p>
        {type === "mic" && (
          <div className={styles.bar}>
            <div style={{width: 33 * micTestLevel * 2 + "px"}} />
          </div>
        )}
        <button className={styles.test_btn} onClick={() => onClickTest(type)}>
          {isTestMode ? (
            type === "mic" ? (
              <FormattedMessage id="ID_VOICE_CHAT_SETTING_TEST_ING_BTN" />
            ) : (
              <FormattedMessage id="ID_VOICE_CHAT_SETTING_TEST_PLAY_BTN" />
            )
          ) : (
            <FormattedMessage id="ID_VOICE_CHAT_SETTING_TEST_BTN" />
          )}
        </button>
      </div>
      <div className={styles.dropdown_area}>
        {list.length > 0 ? (
          <div className={styles.current_device} onClick={() => onClickList(type)}>
            <span>{currentDevice.label}</span>
            <img className={listOpen ? styles.rotate : ""} src={dropdownIcon} alt="" />
          </div>
        ) : (
          <FormattedMessage id={`ID_VOICE_CHAT_SETTING_${type.toUpperCase()}_PLACEHOLDER`} />
        )}
        {list.length > 0 && listOpen && (
          <ul className={styles.device_list}>
            {list
              .filter(item => item.deviceId !== "default")
              .map(({label, deviceId}, i) => (
                <li key={i} onClick={() => onClickDevice(type, deviceId)}>
                  {label}
                </li>
              ))}
          </ul>
        )}
      </div>
      <div className={styles.content_info}>
        <img src={imgSrc} alt="" />
        <div className={styles.slide_container}>
          <input
            type="range"
            min="0"
            max="100"
            className={styles.slider}
            value={value}
            onChange={({target}) => onChange(type, Number(target.value))}
          />
        </div>
        <span className={styles.count}>{value}</span>
      </div>
    </div>
  );
};

export default View;
